import { render, staticRenderFns } from "./TrainingTeachersForm.vue?vue&type=template&id=26c1c540&"
import script from "./TrainingTeachersForm.vue?vue&type=script&lang=js&"
export * from "./TrainingTeachersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports